import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faHeart, faUser } from '@fortawesome/free-solid-svg-icons'
import Paper from '@material-ui/core/Paper'

import * as configActions from '../../actions/Config'
import * as newsFeedActions from '../../actions/NewsFeed'
import * as Functions from '../../../helpers/Functions'
import * as Constants from '../../../helpers/Constants'
import * as Styles from './styles'
import * as Strings from './strings'

class FeedItems extends Component {
  state = {
    showAllComments: false
  }

  getApartment(apartmentId) {
    const { data } = this.props
    const apartments = data.community.apartments

    if (apartmentId) {
      for (let i = 0; i < apartments.length; i++) {
        if (apartments[i].id.toString() === apartmentId.toString()) {
          return Strings.default.APARTMENT + ' ' + apartments[i].number
        }
      }
    }

    return Strings.default.NOT_AVAILABLE
  }

  // NOTE: Not used atm.
  requestDeleteComment(postId, commentId) {
    this.props.showAlert(
      Strings.default.REQUEST_REMOVE_COMMENT,
      Strings.default.REQUEST_REMOVE_COMMENT_INFO,
      Constants.TWO_BUTTONS,
      {
        title: Strings.default.NO,
        onPress: () => {}
      },
      {
        title: Strings.default.YES,
        onPress: () => {}
      }
    )
  }

  renderComments(postId, comments) {
    const { showAllComments } = this.state
    const viewableComments = []

    if (showAllComments) {
      viewableComments.push(
        <a
          onClick={() => this.setState({ showAllComments: false })}
          style={Styles.default.commentsOptions}
        >
          {Strings.default.HIDE_COMMENTS}
        </a>
      )

      comments.forEach(comment =>
        viewableComments.push(
          <CommentItem
            sender={this.getApartment(comment.apartmentId)}
            comment={comment.comment}
            date={Functions.getTimeAgo(comment.createdAt)}
          />
        )
      )
    } else {
      if (comments.length > 2) {
        viewableComments.push(
          <a
            onClick={() => this.setState({ showAllComments: true })}
            style={Styles.default.commentsOptions}
          >
            {Strings.default.SHOW_ALL_COMMENTS}
          </a>
        )
      }

      if (comments.length > 0) {
        for (let i = comments.length - 2; i <= comments.length - 1; i++) {
          if (i >= 0)
            viewableComments.push(
              <CommentItem
                sender={this.getApartment(comments[i].apartmentId)}
                comment={comments[i].comment}
                date={Functions.getTimeAgo(comments[i].createdAt)}
              />
            )
        }
      }
    }

    return viewableComments
  }

  render() {
    const { data, user, newsFeed } = this.props
    const posts = data.posts

    if (posts.length === 0) {
      return <p>{Strings.default.NO_POSTS}</p>
    }

    return posts.map((post, index) => {
      return (
        <Paper style={Styles.default.container}>
          <div style={Styles.default.postContainer}>
            <div style={{ flexDirection: 'row', display: 'flex' }}>
              <FontAwesomeIcon
                icon={faUser}
                style={{ fontSize: 40 }}
                color={'#90949c'}
              />
              <div style={Styles.default.threadPosterStyle}>
                <p style={Styles.default.threadPosterHeaderStyle}>
                  {Strings.default.THE_BOARD}
                </p>
                <p style={Styles.default.threadPosterTimeAgoStyle}>
                  {Functions.getTimeAgo(post.createdAt)}
                </p>
              </div>
            </div>
            {newsFeed.isDeletingPost.indexOf(post.id) !== -1 ? null : (
              <a
                onClick={() =>
                  this.props.showAlert(
                    Strings.default.REQUEST_REMOVE_POST,
                    Strings.default.REQUEST_REMOVE_POST_INFO,
                    Constants.TWO_BUTTONS,
                    {
                      title: Strings.default.NO,
                      onPress: () => {}
                    },
                    {
                      title: Strings.default.YES,
                      onPress: () =>
                        this.props.tryDeletePost(
                          user.token,
                          data.community.id,
                          post.id,
                          (h, i, t, b) => this.props.showAlert(h, i, t, b)
                        )
                    }
                  )
                }
                style={{ padding: 10 }}
              >
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{ fontSize: 16 }}
                  color={'#90949c'}
                />
              </a>
            )}
          </div>
          <p style={Styles.default.textStyle}>{post.text}</p>
          <div style={Styles.default.likesAndCommentsContainerStyle}>
            <div
              style={{
                flexDirection: 'row',
                display: 'flex'
              }}
            >
              <FontAwesomeIcon
                icon={faHeart}
                style={{ fontSize: 13 }}
                color={'#f25268'}
              />
              <p style={Styles.default.numberOfLikesStyle}>
                {post.likes.length}
              </p>
            </div>
          </div>
          {this.renderComments(post.id, post.comments)}
        </Paper>
      )
    })
  }
}

const CommentItem = ({ comment, date, sender }) => {
  return (
    <div style={Styles.default.commentContainer}>
      <FontAwesomeIcon
        icon={faUser}
        style={{ fontSize: 25, marginRight: 7, marginLeft: '1%' }}
        color={'#90949c'}
      />
      <div style={Styles.default.innerCommentContainer}>
        <div style={Styles.default.informationCommentContainer}>
          <p style={Styles.default.senderText}>{sender}</p>
          <p style={Styles.default.date}>{date}</p>
        </div>
        <p style={Styles.default.comment}>{comment}</p>
      </div>
    </div>
  )
}

function mapStateToProps({ user, newsFeed, data }) {
  return { user, newsFeed, data }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...newsFeedActions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedItems)



// WEBPACK FOOTER //
// ./src/components/containers/FeedItems/index.js